import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const STNOutwardReportAllPrint = () => {
  const [reportData, setReportData] = useState([]);
  const [grandTotal, setGrandTotal] = useState('0.00');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // Filter states
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const [filters, setFilters] = useState({
    branchID: queryParams.get("branchID") || "8",
    stnreqno: queryParams.get("stnreqno") || "",
    search_fromdate: queryParams.get("search_fromdate") || "01/01/2022",
    search_todate: queryParams.get("search_todate") || "06/08/2025",
    requestedstore: queryParams.get("requestedstore") || "Select",
    status: queryParams.get("status") || "Select",
    type: queryParams.get("type") || "Select",
  });

  const [data, setData] = useState([]);
  
  // Fetch data from API
  const fetchReportData = async () => {
    try {
      setLoading(true);
      const queryParams = new URLSearchParams(filters).toString();
      const response = await fetch(`http://nissi-india.com/api/stnOutward_rpt?${queryParams}`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      console.log("Fetched data:", data);
      
      if (data.success) {
        setReportData(data.data || []);
        setGrandTotal(data.grandTotal || '0.00');
        setError(null);
      } else {
        throw new Error('API returned unsuccessful response');
      }
    } catch (err) {
      console.error('Error fetching report data:', err);
      setError(err.message);
      setReportData([]);
      setGrandTotal('0.00');
    } finally {
      setLoading(false);
    }
  };

  // Fetch data on component mount
  useEffect(() => {
    fetchReportData();
  }, []);

  // Format date function
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB');
  };

  // Handle filter change
  const handleFilterChange = (key, value) => {
    setFilters(prev => ({
      ...prev,
      [key]: value
    }));
  };

  // Handle search/refresh
  const handleSearch = () => {
    fetchReportData();
  };

  if (loading) {
    return (
      <div className="max-w-7xl mx-auto p-6 bg-white font-sans text-sm">
        <div className="flex items-center justify-center h-64">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
            <p className="text-gray-600">Loading report data...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto p-6 bg-white font-sans text-sm">
      {/* Error Display */}
      {error && (
        <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded no-print">
          <p className="text-sm">
            <strong>Error:</strong> {error}
          </p>
        </div>
      )}

      {/* Main Report Container */}
      <div className="border-4 border-gray-400 bg-gray-100 p-1">
        <div className="bg-white border-2 border-gray-600">
          
          {/* Header Tab */}
          <div className="bg-gray-200 border-b border-gray-400 px-4 py-2">
            <span className="font-bold text-sm">Main Report</span>
          </div>

          {/* Content Area */}
          <div className="p-4">
            
            {/* Header Section */}
            <div className="border-2 border-black mb-4">
              <div className="flex items-start p-4">
                {/* Logo Section */}
                <div className="w-32 h-20 border-2 border-black mr-6 flex items-center justify-center bg-white">
                  <div className="text-center">
                    <div className="w-12 h-8 bg-black mx-auto mb-1 flex items-center justify-center">
                      <span className="text-white text-xs font-bold">LOGO</span>
                    </div>
                    <div className="text-xs font-bold">NISSI INFOTECH</div>
                    <div className="text-xs">PVT LTD</div>
                  </div>
                </div>
                
                {/* Company Info */}
                <div className="flex-1 text-center">
                  <h1 className="text-xl font-bold mb-1">Nissi Infotech</h1>
                  <p className="text-sm mb-1">NISSI</p>
                  <p className="text-sm font-bold mb-1">CIVIL CONSTRUCTION</p>
                  <p className="text-xs">
                    3/42-12, Nagappa colony, kavundampai,644003,Tamil Nadu, India,<br/>
                    Phone No :9003744644 infraconsoft-implementation@nissiinfotech.in
                  </p>
                </div>
              </div>
            </div>

            {/* Report Title */}
            <div className="text-center border-b-2 border-black pb-2 mb-4">
              <h2 className="text-lg font-bold underline">STN Outward Report</h2>
            </div>

            
            {/* Data Table */}
            <div className="border-2 border-black mb-4">
              <table className="w-full text-xs">
                <thead>
                  <tr className="bg-white">
                    <th className="border border-black px-2 py-3 text-center w-16">S.No</th>
                    <th className="border border-black px-2 py-3 text-center w-40">STN Outward No</th>
                    <th className="border border-black px-2 py-3 text-center w-24">Date</th>
                    <th className="border border-black px-2 py-3 text-center w-32">To Branch</th>
                    <th className="border border-black px-2 py-3 text-center w-24">Amount</th>
                    <th className="border border-black px-2 py-3 text-center w-24">Status</th>
                    <th className="border border-black px-2 py-3 text-center w-32">Type</th>
                  </tr>
                </thead>
                <tbody>
                  {reportData.length > 0 ? reportData.map((item, index) => (
                    <tr key={item.fld_STN_Outwardid || index} className="hover:bg-gray-50">
                      <td className="border border-black px-2 py-2 text-center">{index + 1}</td>
                      <td className="border border-black px-2 py-2 text-center">
                        <button 
                          className="text-blue-600 hover:text-blue-800 underline"
                          onClick={() => {
                            // Navigate to detail view - you can implement this
                            console.log('Navigate to detail for ID:', item.fld_STN_Outwardid);
                          }}
                        >
                          {item.OutwardNo}
                        </button>
                      </td>
                      <td className="border border-black px-2 py-2 text-center">{formatDate(item.OutwardDate)}</td>
                      <td className="border border-black px-2 py-2 text-center">{item.ToB}</td>
                      <td className="border border-black px-2 py-2 text-right">{item.AmountNew}</td>
                      <td className="border border-black px-2 py-2 text-center">{item.isoutwardclosed}</td>
                      <td className="border border-black px-2 py-2 text-center">{item.STNType}</td>
                    </tr>
                  )) : (
                    <tr>
                      <td className="border border-black px-2 py-8 text-center" colSpan="7">
                        {loading ? 'Loading...' : 'No data available'}
                      </td>
                    </tr>
                  )}
                  
                  {/* Empty rows to maintain table height */}
                  {reportData.length < 10 && [...Array(Math.max(0, 10 - reportData.length))].map((_, index) => (
                    <tr key={`empty-${index}`} className="h-8">
                      <td className="border border-black px-2 py-2"></td>
                      <td className="border border-black px-2 py-2"></td>
                      <td className="border border-black px-2 py-2"></td>
                      <td className="border border-black px-2 py-2"></td>
                      <td className="border border-black px-2 py-2"></td>
                      <td className="border border-black px-2 py-2"></td>
                      <td className="border border-black px-2 py-2"></td>
                    </tr>
                  ))}

                  {/* Total Row */}
                  <tr className="bg-gray-100">
                    <td className="border border-black px-2 py-2 font-bold text-center" colSpan="4">Total</td>
                    <td className="border border-black px-2 py-2 text-right font-bold">₹ {grandTotal}</td>
                    <td className="border border-black px-2 py-2" colSpan="2"></td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Summary */}
             

          </div>
        </div>
      </div>
       <div className="border-2 border-black print:border-black">
          <div className="p-2 text-right text-xs">
            <span className="font-bold">Page 1 of 1</span>
          </div>
          <div className="border-t-2 border-black p-2 text-xs print:border-black">
            Report generated by ERP-Software - www.infraconsoft.com owned by <span className="font-bold">www.nissiinfotech.com</span>
          </div>
        </div>

      {/* Print Button */}
      <div className="mt-6 text-center no-print">
        <button
          onClick={() => window.print()}
          className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition-colors mr-4"
        >
          Print Report
        </button>
        <button
          onClick={handleSearch}
          className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition-colors"
        >
          Refresh Data
        </button>
      </div>

      {/* Print Styles */}
      <style jsx>{`
        @media print {
          .no-print {
            display: none !important;
          }
          body {
            margin: 0;
            padding: 10mm;
            background: white !important;
          }
          * {
            color: black !important;
            background: white !important;
            border-color: black !important;
          }
        }
      `}</style>
    </div>
  );
};

export default STNOutwardReportAllPrint;